import { useApi } from '@/composables/use-api'
import { UserInfo, UserInfoPayload } from './types'

export const UserApi = {
  async userProfileRequest() {
    const result = await useApi().get<UserInfo>('../users/me/')

    return result.data
  },

  async updateUserProfileRequest(userInfo: UserInfoPayload) {
    const result = await useApi().patch<UserInfo>('../users/me/', userInfo)

    return result.data
  },
}
